import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/contact/page.tsx");
